<template>
    <div class="news" v-onmedia="matchMedia">
     
            <!-- Section: News -->
            <section id="news" class="section pb-5 wow fadeIn" data-wow-delay="0.3s" 
                style="border-top:1px solid white;padding-bottom: 0px!important;">

                <div style="background-color:#0187c044;width:100%;height:100%;">
                <!-- Section heading -->
                <h1 class="section-heading h1 pt-5 mt-4 mb-5" 
                    style="color:#757575;margin-top: 0px!important;padding-top:60px!important;">News</h1> 
                <!--Grid row-->
                
            <!-- <div class="row mx-xs-0 mx-sm-1 mx-md-3 mx-lg-5">
                <ul class="juicer-feed" data-feed-id="kmueller222" data-origin="embed-code" data-per="8"><h1 class="referral"></h1></ul>
            </div> -->

                <div class="container" style="max-width:100%;padding-bottom:50px;">
                    <div class="row mx-xs-0 mx-sm-1 mx-md-3 mx-lg-5">

                        <!--<ul class="juicer-feed" data-feed-id="heimann-s-agentur" data-origin="embed-code" data-per="8"><h1 class="referral"></h1></ul>
-->
<iframe src="https://embedsocial.com/api/pro_hashtag/60877d22d7d9b8ff9f6c50b271c4c9e0d73d377a" width="1200px" height="1000px" frameborder="0" marginheight="0" marginwidth="0"></iframe>                        
<!--<iframe src='https://www.heimanns-agentur.de/juicer.html' frameborder='0' width='1200' height='1000' style='display:block;margin:0 auto;'></iframe>-->

                        <!-- <facebook 
                            v-for="feed in feeds" 
                            :feed="feed"
                            :key="feed.id"></facebook> -->
                    

                    <!--Grid column
                    <div class="col-md-12 text-center mb-3">
                        <div class="fb-page" 
                        data-href="https://www.facebook.com/Heimanns-Agentur-174592245925723/" 
                        :data-width="facebookWidth"
                        data-tabs="timeline" 
                        data-small-header="true" 
                        data-adapt-container-width="true" 
                        data-hide-cover="true" 
                        data-show-facepile="false">
                            <blockquote cite="https://www.facebook.com/Heimanns-Agentur-174592245925723/" class="fb-xfbml-parse-ignore">
                                <a href="https://www.facebook.com/Heimanns-Agentur-174592245925723/">Facebook</a>
                            </blockquote>
                        </div>
                    </div>
                    -->
                
                    </div>
                </div>
                </div>
                <!--Grid row-->
            </section>
    </div>
</template>

<script>
import Facebook from "./Facebook"
import url from './../config.js'

export default {
    props : {
        'actorsPerLine': {
            type: String
        }
    },
    components: {
        facebook: Facebook
    },
    data () {
        return {
            facebookWidth : 500,
            feeds:[]
        }
    },
    mounted() {
        let externalScript = document.createElement('script')
        //externalScript.setAttribute('src', 'https://assets.juicer.io/embed.js')
        document.head.appendChild(externalScript)
    },
    created() {
        this.$http.get(url.scheme + '://relaunch2018.heimanns-agentur.de/twitter/twitter.php?id=174592245925723&limit=12&out=intro,thumb,text,user')
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    this.feeds=[];
                    data.responseData.feed.entries.forEach(onefeed => {
                        //console.log("Feed: " + JSON.stringify(onefeed));
                        if(this.feeds.length < 12) {
                            if(onefeed.content != "") {
                                this.feeds.push(onefeed);
                            }
                        }   
                    });

                    //this.feeds = data.responseData.feed.entries;
                    //console.log("Feeds " + JSON.stringify(this.feeds));
                    
        });
        
    }, 
    methods: {
        matchMedia(alias, matches) {
            if (alias === 'xs' && matches) {
                this.facebookWidth = '360';
            } else if (alias === 'sm' && matches) {
                this.facebookWidth = '500';
            } else if (alias === 'md' && matches) {
                this.facebookWidth = '500';
            } else if (alias === 'lg' && matches) {
                this.facebookWidth = '500';
            } else if (alias === 'xl' && matches) {
                this.facebookWidth = '500';
            } 
         }

    }
}
</script>

<style>

    @import 'https://assets.juicer.io/embed.css';

    .news {
        background-color:#0187c0bb;
        background: url("./../assets/img/strahlen.png") top right no-repeat;
        background-attachment:fixed;
        /*background-color: rgba(255,255,255,0.5);*/
        /*box-shadow: 0 0px 50px 0 rgba(0,0,0,.16);*/
        box-shadow: 0 0px 150px 0 rgba(0,0,0,.16);
    }
    .facebook-feeds {
        width:100%;
        background:#0188c0;
    }

    .juicer-feed.modern .j-message {
        /* font-family: 'rockwell_stdregular', sans-serif; */
        font-weight: 700;
    }

</style>



// WEBPACK FOOTER //
// src/components/News.vue